export const summaryRows: Array<[string, string]> = [
  ['9 tomos completos', 'Fundamentos, sensores, PLC, electroneumática, motores, redes, HMI/SCADA, prácticas y planificación docente'],
  ['5 bonos estratégicos', 'Proyectos, evaluaciones, diagramas visuales, documentación técnica y seguridad'],
  ['150 proyectos de automatización listos', 'Para elegir, adaptar e implementar en tu aula-taller'],
  ['100 ejercicios y desafíos prácticos', 'Propuestas de complejidad creciente para cada tecnología'],
  ['Kit completo de evaluaciones', 'Rúbricas, listas de cotejo, instrumentos para proyectos'],
  ['Banco de diagramas y esquemas', 'Recursos visuales para explicar conceptos técnicos complejos'],
  ['155 formularios y plantillas', 'Documentación técnica lista para imprimir y utilizar'],
  ['Material de seguridad industrial', 'Puesta en marcha segura y escenarios de riesgo'],
  ['Casos reales resueltos', 'Con datos de máquinas y procesos argentinos'],
  ['Contenido técnico actualizado', 'Normas vigentes, nuevas tecnologías, industria 4.0'],
  ['Acceso inmediato', 'Descarga directa en menos de 5 minutos'],
  ['Acceso de por vida y actualizaciones', 'Sin costos adicionales'],
  ['Garantía de 7 días', 'Sin preguntas ni formularios'],
];
